export default __webpack_public_path__ + "static/media/Cloak of the Battle Hardened.1181c8f6.jpg";